/* Packages */
import React from 'react';
import { render } from 'react-dom';

const accessoriesPreviewNodes = Array.from(document.querySelectorAll('[data-accessories-preview]'));
if (accessoriesPreviewNodes.length) {
    import(/* webpackChunkName: "AccessoriesPreview" */ './components/AccessoriesPreview').then(({ default: AccessoriesPreview }) => {
        accessoriesPreviewNodes.forEach((node) => render(<AccessoriesPreview {...(JSON.parse(node.dataset.accessoriesPreview || '{}'))}/>, node));
    });
}
